module.exports = "<div class=\"row\">\n  <div class=\"col-12 nprl\">\n    <div class=\"col-sm-2\" style=\"padding-right:0px;\">\n      <span class=\"header pull-right\"> היצע שירותים דיגיטליים</span>\n    </div>\n    <div class=\"col-md-3 pull-left\" style=\"padding-top: 10px;\">\n      space\n    </div>\n    <div class=\"col-md-3 pull-left\" style=\"padding-top: 10px;\">\n      חחחחחח\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/blocks/table-header/table-header.component.html
// module id = ./src/app/component/blocks/table-header/table-header.component.html
// module chunks = main